import store from "@packages/store";
import Vue from "vue";

export default {
    async load({ pagination, filters }) {
        const leads = await Vue.api.leads.load({ pagination, filters });

        store.commit("SET_LEADS_LIST", leads);

        return leads;
    },

    async count({ filters }) {
        const count = await Vue.api.leads.count({ filters });

        store.commit("SET_LEADS_COUNT", count);

        return count;
    },

    async csv({ filters }) {
        const csv = await Vue.api.leads.csv({ filters });

        return csv;
    },
};
